import request from '@/utils/httpRequest'

export default class receiptService {
    queryById(id) {
        return request({
            url: '/receiving/view',
            method: 'get',
            params: {
                id: id
            },
            class:'mater'
        })
    }
}
